import React from "react";
import { Link } from "react-router-dom";

const Cta = () => {
  return (
    <div className="bg-gray-50 text-black py-10 sm:py-20 lg:py-20">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-500 mb-6 sm:mb-8">
          Transform Today
        </p>

        <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin mb-8 sm:mb-12 leading-snug">
          Ready to Lead
          <br />
          <em>the AI Era?</em>
        </h2>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center">
          <Link to="/programs">
            <button className="group border border-black px-10 sm:px-12 py-3.5 sm:py-4 text-[11px] sm:text-sm tracking-[0.2em] uppercase hover:bg-black hover:text-white transition-all duration-300">
              <span className="group-hover:tracking-[0.3em] transition-all duration-300">
                Start Your Journey
              </span>
            </button>
          </Link>

          <div className="w-px h-10 sm:h-12 bg-gray-300 hidden sm:block" />

          <Link to="/consultation">
            <button className="text-[11px] sm:text-sm tracking-[0.2em] uppercase text-gray-500 hover:text-black transition-colors">
              Book Consultation →
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cta;
